module.exports = __webpack_public_path__ + "img/53_29.0e1d6d06.png";